import React from 'react';
import NextButton from './NextButton';

const FinalClue: React.FC = () => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      }}
    >
      <p>
        Time to head home and have some much deserved downtime before our date!
        Grab an Uber and relax for a bit before getting ready for dinner
      </p>
      <img src='engagement.png' />
      <p style={{ textAlign: 'center' }}>Can't wait to see you 🥰🥰🥰</p>
    </div>
  );
};

export default FinalClue;
